export const getVehicleTypeFromVehicleSlug = (slug: string) => slug.split("_")[0]